import React from 'react'
import { ProgressCircle } from '../../ProgressCircle/ProgressCircle'
import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import { QVBreakdown } from './QVBreakdown'

export type ComissionProps = {
  earnedQV: string
  outstandingQV: string
  totalQV: string
  percent: number
  totalCommision: string
  bonusTotal: string
  grandTotal: string
  isMobile?: boolean
}

export const ComissionBreakdown = (props: ComissionProps) => {
  const {
    earnedQV,
    outstandingQV,
    totalQV,
    percent,
    totalCommision,
    bonusTotal,
    grandTotal,
    isMobile,
  } = props
  const montserratFont = 'Montserrat, san serif'

  return (
    <Flex
      width="100%"
      maxWidth={isMobile ? 'unset' : '220px'}
      flexDirection="column"
      style={{
        borderRadius: '.5rem',
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Flex
        position="relative"
        flexDirection="row"
        inset=".5rem"
        backgroundColor="#F8F8F8"
      >
        <Div position="absolute" bottom="16px">
          <ProgressCircle percent={percent} size={70} />
        </Div>
        <QVBreakdown
          earned={earnedQV}
          outstanding={outstandingQV}
          total={totalQV}
        />
      </Flex>
      <Flex
        backgroundColor="#fff"
        justifyContent="space-between"
        inset={{ horizontal: '.5rem' }}
      >
        <Flex flexDirection="column">
          <Text
            type="body"
            style={{
              fontSize: '.825rem',
              fontWeight: 500,
              fontFamily: montserratFont,
              color: '#404040',
              whiteSpace: 'nowrap',
            }}
            content="Total Comission"
          />
          <Text
            type="body"
            style={{
              fontSize: '.825rem',
              fontWeight: 500,
              fontFamily: montserratFont,
              color: '#404040',
              whiteSpace: 'nowrap',
            }}
            content="50% Bonus"
          />
        </Flex>
        <Flex flexDirection="column">
          <Text
            type="body"
            style={{
              fontSize: '.925rem',
              fontWeight: 600,
              fontFamily: montserratFont,
              color: '#404040',
              whiteSpace: 'nowrap',
            }}
            content={totalCommision}
          />
          <Text
            type="body"
            style={{
              fontSize: '.925rem',
              fontWeight: 600,
              fontFamily: montserratFont,
              color: '#404040',
              whiteSpace: 'nowrap',
            }}
            content={bonusTotal}
          />
        </Flex>
      </Flex>
      <Flex
        justifyContent="space-between"
        inset={{ horizontal: '.5rem' }}
        style={{
          background:
            'linear-gradient(74deg, rgba(52, 227, 223, 0.70) 16.27%, rgba(2, 174, 238, 0.70) 86.38%), #FFF',
          borderBottomLeftRadius: 'inherit',
          borderBottomRightRadius: 'inherit',
        }}
      >
        <Text
          type="body"
          style={{
            fontSize: '.825rem',
            fontWeight: 600,
            fontFamily: montserratFont,
            color: '#fff',
            whiteSpace: 'nowrap',
          }}
          content="Total"
        />
        <Text
          type="body"
          style={{
            fontSize: '.825rem',
            fontWeight: 500,
            fontFamily: montserratFont,
            color: '#fff',
            whiteSpace: 'nowrap',
          }}
          content={grandTotal}
        />
      </Flex>
    </Flex>
  )
}
